/**
 * AgentBriefTab — the texting agent's per-study knowledge brief (agent_brief
 * artifact, agent plan §8.1). Thin wrapper over TextArtifactPanel: generate
 * from the extracted protocol/ICF, hand-edit, publish. The §8.1 gate runs
 * server-side at publish (required sections + no [CONFIRM…] placeholders), and
 * the study readiness checklist (Settings → Texting agent) requires a
 * published brief before the agent can be enabled.
 */
import { Link } from 'react-router-dom';
import { StudyDetailResponse } from '../../types';
import TextArtifactPanel from './TextArtifactPanel';

export default function AgentBriefTab({ detail, isAdmin, onChanged }: { detail: StudyDetailResponse; isAdmin: boolean; onChanged: () => void }) {
  return (
    <div className="space-y-3">
      <p className="text-xs text-gray-500 dark:text-gray-400">
        The published brief is the texting agent's entire knowledge of this study — it can only say
        what this document says. Publishing checks the required sections, and the{' '}
        <Link to="/crm/settings/agent" className="font-medium text-primary-600 hover:underline dark:text-primary-400">
          readiness checklist
        </Link>{' '}
        needs a published brief before the agent can be enabled for this study.
      </p>
      <TextArtifactPanel
        detail={detail}
        artifactType="agent_brief"
        title="Agent brief"
        emptyHint="No brief yet. With the protocol/ICF extracted (Documents tab), generate a draft — then read every line, fix anything wrong, and publish. The agent grounds every reply in this text."
        isAdmin={isAdmin}
        onChanged={onChanged}
      />
    </div>
  );
}
